import { render, staticRenderFns } from "./ValidationStep.vue?vue&type=template&id=18906436"
import script from "./ValidationStep.ts?vue&type=script&lang=ts&external"
export * from "./ValidationStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18906436')) {
      api.createRecord('18906436', component.options)
    } else {
      api.reload('18906436', component.options)
    }
    module.hot.accept("./ValidationStep.vue?vue&type=template&id=18906436", function () {
      api.rerender('18906436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/ValidationStep.vue"
export default component.exports